<template>

  <div class="filters">
    <div>
      <v-text-field :value="filters.search"
                    @input="debounce(() => filters.search = $event, 300)"
                    :label="$t('shared.search')"
                    prepend-icon="search"></v-text-field>
    </div>

    <div>
      <asset-types-tree v-model="filters.assetTypes"></asset-types-tree>
    </div>

    <div>
      <device-types-select v-model="filters.deviceTypes" :multiple="true"></device-types-select>
    </div>
  </div>

</template>

<script>
  import {mapMutations, mapState} from 'vuex'
  import debounce from '../../helpers/debounce.es6'
  import UsersSelect from '../../users/components/users-select'
  import AssetTypesTree from '../../asset-types/asset-types-tree'
  import AssetsTree from '../../assets/components/assets-tree'
  import DeviceTypesSelect from '../../devices/device-types-select'


  export default {
    name: 'assets-filters',
    mixins: [ debounce ],

    data () {
      return {
        types: [
          { label: 'Maintenance', value: 'maintenance' },
          { label: 'Failure', value: 'failure' },
        ]
      }
    },

    computed: {
      ...mapState('filters/assets', [
        'filters'
      ]),
    },

    methods: {
      ...mapMutations('filters/assets', [
        'saveFilters'
      ])
    },

    watch: {
      filters: {
        deep: true,
        handler () {
          this.saveFilters(this.filters)
          this.$emit('change', this.filters)
        }
      }
    },

    components: {
      DeviceTypesSelect,
      AssetTypesTree,
      AssetsTree,
      UsersSelect
    }
  }
</script>

<style scoped lang="scss">

</style>
